import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import '@mantine/carousel/styles.layer.css';
import '@mantine/dropzone/styles.layer.css';
import '@mantine/nprogress/styles.layer.css';
import '@mantine/charts/styles.layer.css';
import './global.css';
import './i18n';

import { theme } from '@/theme';

import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import { ConvexQueryCacheProvider } from "convex-helpers/react/cache";
import { HelmetProvider } from 'react-helmet-async';
import { ColorSchemeScript, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { AnimatePresence } from 'framer-motion';

import { Router } from '@/routes/router';

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

export function App() {
  return (
    <ConvexAuthProvider client={convex}>
      <ConvexQueryCacheProvider>
        <HelmetProvider>
          <ColorSchemeScript forceColorScheme="dark" />
          <MantineProvider theme={theme} forceColorScheme="dark">
            <Notifications position="top-right" limit={1} />
            <ModalsProvider>
              <AnimatePresence mode="popLayout">
                <Router />
              </AnimatePresence>
            </ModalsProvider>
          </MantineProvider>
        </HelmetProvider>
      </ConvexQueryCacheProvider>
    </ConvexAuthProvider>
  );
}
